import React from 'react'
import clsx from 'clsx'

import containerStyles from './container.module.css'

interface PageContainerProps {
  children: React.ReactNode
  className?: string
}

/**
 * Shared responsive container aligned with RuangGTKHeader.
 * Uses the same CSS class as the header — content always edge-aligns
 * with the header at every breakpoint automatically.
 */
const PageContainer = ({ children, className }: PageContainerProps) => (
  <div
    className={clsx(
      containerStyles['rgtk-page-container'],
      'w-full',
      className
    )}
  >
    {children}
  </div>
)

export default PageContainer
